import { render, staticRenderFns } from "./AdManagement.vue?vue&type=template&id=567a1875&scoped=true"
import script from "./AdManagement.vue?vue&type=script&lang=js"
export * from "./AdManagement.vue?vue&type=script&lang=js"
import style0 from "./AdManagement.vue?vue&type=style&index=0&id=567a1875&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567a1875",
  null
  
)

export default component.exports